import createAttachmentFiles from '../../utils/createAttachmentFiles';
import { getItem } from '../../utils/getItem';
import { getUserMailboxInfo } from 'owa-client-ids';
import { ComposeTarget, lazyReplyToMessage } from 'owa-mail-compose-store';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export function displayReplyForm(referenceItemId, isReplyAll, htmlBody, attachments) {
    if (isMailFeatureEnabled('rp-popouts')) {
        var item = getItem(referenceItemId);
        var conversationId = item ? item.ConversationId.Id : null;
        var attachmentFiles = createAttachmentFiles(attachments);
        lazyReplyToMessage.importAndExecute({ Id: referenceItemId, mailboxInfo: getUserMailboxInfo() }, isReplyAll, true /* useFullCompose */, 'AddIns', [], conversationId, htmlBody, ComposeTarget.Popout, attachmentFiles);
    }
}
//# sourceMappingURL=DisplayReplyFormAdapter.js.map